import { Component, Input, OnInit, inject } from "@angular/core";
import { Store as NgrxStore } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { SorCodeStore } from "@app/services/store/sor-code-store";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Store } from "@bryntum/core-thin";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { VisitTypeStore } from "@app/services/store/visit-type-store";
import { SorCode } from "@app/models/rest/sor-code";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton, MatIconButton } from "@angular/material/button";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { DataImportService } from "@app/services/data-import/data-import.service";
import { DataImportWizardComponent } from "@app/view/setup/data-import/data-import-wizard/data-import-wizard.component";

@Component({
  selector: "app-sor-code-list",
  templateUrl: "./sor-code-list.component.html",
  styleUrls: ["./sor-code-list.component.scss"],
  imports: [
    MatToolbar,
    MatButton,
    MatIconButton,
    GridComponent,
    MatPaginator,
    TranslatePipe,
    MatTooltip,
    MatIcon
  ]
})
export class SorCodeListComponent
  extends BaseDataTablePageDirective<SorCode>
  implements OnInit
{
  sorCodeStore: SorCodeStore;
  protected store: NgrxStore<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  protected visitTypeStore = inject(VisitTypeStore);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;
  private dataImportService = inject(DataImportService);

  public visitTypeListStore = new Store({
    data: []
  });
  @Input()
  public columns: object[] = [
    {
      field: "code",
      text: "Code",
      flex: 1,
      editor: true
    },
    {
      field: "description",
      text: "Description",
      flex: 3,
      editor: true
    },
    {
      field: "smv",
      text: "SMV",
      flex: 1,
      editor: true
    },
    {
      text: "Visit Type",
      field: "visitType",
      flex: 1,
      renderer: ({ record }) =>
        record.visitType
          ? record.visitType.description
            ? record.visitType.description
            : "none"
          : "none",
      editable: false,
      editor: {
        type: "dropdown",
        // items: this.visitTypes,
        store: this.visitTypeListStore,
        displayField: "description",
        valueField: null
      }
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const sorCodeStore = inject(SorCodeStore);
    const store = inject<NgrxStore<any>>(NgrxStore);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      sorCodeStore,
      store,
      dialog,
      "SorCode",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.sorCodeStore = sorCodeStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    this.visitTypeStore.loadAll().then((value) => {
      this.visitTypeListStore.add(value.resources);
    });

    super.ngOnInit();
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.insert(0, {
      code: "",
      description: "",
      smv: 1,
      visitType: null
    });
  }

  openImportWizard(): void {
    const dialogRef = this.dialog.open(DataImportWizardComponent, {
      width: "800px",
      maxHeight: "90vh",
      data: { entityType: "SOR_CODE" }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Refresh the list after successful import
        this.ngOnInit();
      }
    });
  }

  async exportToExcel(): Promise<void> {
    try {
      await this.dataImportService.exportSorCodesToExcel();
    } catch (error) {
      this.serverErrorHandler.handleClientError("Failed to export SOR codes");
    }
  }
}
